import {isExpired, isSupportUser} from 'helpers/user'
import {getUser, showTrialBanner} from 'selectors/auth'
import {getSystemNotifications} from 'selectors/notifications'

export const HEADER_HEIGHT = 50   // should match headerContainer.scss
export const NOTIFICATION_HEIGHT = 40       // should match systemNotification.scss
export const TRIAL_BANNER_HEIGHT = 40
export const SUPPORT_BANNER_HEIGHT = 40

export const getHeaderHeight = state => {
  if (isExpired(getUser(state))) return 0  // no header in expired state

  const notificationCount = getSystemNotifications(state).length
  const isTrialBanner = showTrialBanner(state)

  const user = getUser(state)
  const supportUser = isSupportUser(user)

  return HEADER_HEIGHT
      + (notificationCount * NOTIFICATION_HEIGHT)
      + (isTrialBanner ? TRIAL_BANNER_HEIGHT : 0)
      + (supportUser ? SUPPORT_BANNER_HEIGHT : 0)
}
